import { Injectable } from '@angular/core';
import { GlobalConstants } from 'src/app/shared/constants/global-constants';
import { Subject, Observable, of } from 'rxjs';
import { CommonHttpService } from './common-http.service';
import { CommonService } from './common.service';
import { StorageService } from './storage.service';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AssessmentService {
  progressDetails: any;
  constructor(private _commonHttpService: CommonHttpService, private storageService: StorageService,
    private commonService: CommonService) { }

  public getUserData(data: any): Observable<any> {
    const url = this.commonService.getFullUrl(GlobalConstants.USER_PROFILE);
    let encryptedRqstBody = {
      rqstBody: this.commonService.encryptUsingAES256(data)
    }
    return this._commonHttpService.post(url, encryptedRqstBody, {}, {})
      .pipe(map((response, error) => {
        if (response) {
          //console.log('userdata response: ', response);
          return response.body;
        } else {
          return error;
        }
      }));
  }

  public getNewUserData(data: any): Observable<any> {
    const url = this.commonService.getFullUrl(GlobalConstants.NEW_USER_PROFILE);
    let encryptedRqstBody = {
      rqstBody: this.commonService.encryptUsingAES256(data)
    }
    return this._commonHttpService.post(url, encryptedRqstBody, {}, {})
      .pipe(map((response, error) => {
        if (response) {
          //console.log('new userdata response: ', response);
          return response.body;
        } else {
          return error;
        }
      }));
  }

  public fetchQuestionnaireList(data: any): Observable<any> {
    const url = this.commonService.getFullUrl(GlobalConstants.FETCH_QUESTIONNAIRE_LIST);
    let encryptedRqstBody = {
      rqstBody: this.commonService.encryptUsingAES256(data)
    }
    return this._commonHttpService.post(url, encryptedRqstBody, {}, {})
      .pipe(map((response, error) => {
        if (response) {
          //console.log('questionnaireList response: ', response);
          return response.body;
        } else {
          return error;
        }
      }));
  }

  public fetchProgressTrackerQuestionnaireList(data: any): Observable<any> {
    const url = this.commonService.getFullUrl(GlobalConstants.PROGRESS_TRACKER_LIST);
    let encryptedRqstBody = {
      rqstBody: this.commonService.encryptUsingAES256(data)
    }
    return this._commonHttpService.post(url, encryptedRqstBody, {}, {})
      .pipe(map((response, error) => {
        if (response) {
          //console.log('questionnaireList response: ', response);
          return response.body;
        } else {
          return error;
        }
      }));
  }

  public fetchReviewQuestionnaireList(data: any): Observable<any> {
    const url = this.commonService.getFullUrl(GlobalConstants.FETCH_REVIEW_QUESTIONNAIRE_LIST);
    let encryptedRqstBody = {
      rqstBody: this.commonService.encryptUsingAES256(data)
    }
    return this._commonHttpService.post(url, encryptedRqstBody, {}, {})
      .pipe(map((response, error) => {
        if (response) {
          //console.log('review questionnaireList response: ', response);
          return response.body;
        } else {
          return error;
        }
      }));
  }

  public fetchSubmittedQuestionnaires(data: any): Observable<any> {
    const url = this.commonService.getFullUrl(GlobalConstants.FETCH_SUBMITTED_QUESTIONNAIRES);
    let encryptedRqstBody = {
      rqstBody: this.commonService.encryptUsingAES256(data)
    }
    return this._commonHttpService.post(url, encryptedRqstBody, {}, {})
      .pipe(map((response, error) => {
        if (response) {
          //console.log('submittedquestionnaireList response: ', response);
          return response.body;
        } else {
          return error;
        }
      }));
  }
  public fetchAssessmentRatings(data: any): Observable<any> {
    const url = this.commonService.getFullUrl(GlobalConstants.FETCH_QUESTIONNAIRE_RATINGS);
    let encryptedRqstBody = {
      rqstBody: this.commonService.encryptUsingAES256(data)
    }
    return this._commonHttpService.post(url, encryptedRqstBody, {}, {})
      .pipe(map((response, error) => {
        if (response) {
          //console.log('AssessmentRatings response: ', response);
          return response.body;
        } else {
          return error;
        }
      }));
  }

  public fetchCountryList(data: any): Observable<any> {
    const url = this.commonService.getFullUrl(GlobalConstants.FETCH_COUNTRIES);
    let encryptedRqstBody = {
      rqstBody: this.commonService.encryptUsingAES256(data)
    };
    return this._commonHttpService.post(url, encryptedRqstBody, {}, {})
      .pipe(map((response, error) => {
        if (response) {
          //console.log('countryList response: ', response);
          return response.body;
        } else {
          return error;
        }
      }));
  }

  public fetchAssessmentQuestions(data: any): Observable<any> {
    let url = this.commonService.getFullUrl(GlobalConstants.FETCH_GENERAL_QUESTIONS);

    let encryptedRqstBody = {
      rqstBody: this.commonService.encryptUsingAES256(data)
    }
    return this._commonHttpService.post(url, encryptedRqstBody, {}, {})
      .pipe(map((response, error) => {
        if (response) {
          //console.log('questions response: ', response);
          return response.body;
        } else {
          return error;
        }
      }));
  }

  public fetchAllQuestions(data: any): Observable<any> {
    let url = this.commonService.getFullUrl(GlobalConstants.FETCH_ALL_QUESTIONS);
    let encryptedRqstBody = {
      rqstBody: this.commonService.encryptUsingAES256(data)
    }
    return this._commonHttpService.post(url, encryptedRqstBody, {}, {})
      .pipe(map((response, error) => {
        if (response) {
          //console.log('all questions response: ', response);
          return response.body;
        } else {
          return error;
        }
      }));
  }

  public fetchUploadedFile(data: any): Observable<any> {
    const url = this.commonService.getFullUrl(GlobalConstants.FETCH_UPLOADED_FILE);
    let encryptedRqstBody = {
      rqstBody: this.commonService.encryptUsingAES256(data)
    }
    return this._commonHttpService.post(url, encryptedRqstBody, {}, {})
      .pipe(map((response, error) => {
        if (response) {
          //console.log('file response: ', response);
          return response.body;
        } else {
          return error;
        }
      }));
  }

  public fetchUploadedFiles(data: any): Observable<any> {
    const url = this.commonService.getFullUrl(GlobalConstants.FETCH_UPLOADED_FILES);
    let encryptedRqstBody = {
      rqstBody: this.commonService.encryptUsingAES256(data)
    }
    return this._commonHttpService.post(url, encryptedRqstBody, {}, {})
      .pipe(map((response, error) => {
        if (response) {
          //console.log('files response: ', response);
          return response.body;
        } else {
          return error;
        }
      }));
  }

  public checkAllQuesSubmitted(data: any): Observable<any> {
    const url = this.commonService.getFullUrl(GlobalConstants.CHECK_ALL_QUES_SUBMITTED);
    let encryptedRqstBody = {
      rqstBody: this.commonService.encryptUsingAES256(data)
    }
    return this._commonHttpService.post(url, encryptedRqstBody, {}, {})
      .pipe(map((response, error) => {
        if (response) {
          //console.log('response: ', response);
          return response.body;
        } else {
          return error;
        }
      }));
  }

  public checkAllQuesReviewed(data: any): Observable<any> {
    const url = this.commonService.getFullUrl(GlobalConstants.CHECK_ALL_QUES_REVIEWED);
    let encryptedRqstBody = {
      rqstBody: this.commonService.encryptUsingAES256(data)
    }
    return this._commonHttpService.post(url, encryptedRqstBody, {}, {})
      .pipe(map((response, error) => {
        if (response) {
          //console.log('response: ', response);
          return response.body;
        } else {
          return error;
        }
      }));
  }

  public fetchCategories(data: any): Observable<any> {
    const url = this.commonService.getFullUrl(GlobalConstants.FETCH_CATEGORIES);
    let encryptedRqstBody = {
      rqstBody: this.commonService.encryptUsingAES256(data)
    }
    return this._commonHttpService.post(url, encryptedRqstBody, {}, {})
      .pipe(map((response, error) => {
        if (response) {
          //console.log('categories response: ', response);
          return response.body;
        } else {
          return error;
        }
      }));
  }

  public fetchAssessmentList(): Observable<any> {
    const url = this.commonService.getFullUrl(GlobalConstants.ASSESSMENT_LIST);
    return this._commonHttpService.get(url, {}, {})
      .pipe(map((response, error) => {
        if (response) {
          return response.body;
        } else {
          return error;
        }
      }));
  }

  public saveQuestionResponse(data: any): Observable<any> {
    const url = this.commonService.getFullUrl(GlobalConstants.SAVE_QUES_RESPONSE);
    let encryptedRqstBody = {
      rqstBody: this.commonService.encryptUsingAES256(data)
    }
    return this._commonHttpService.post(url, encryptedRqstBody, {}, {})
      .pipe(map((response, error) => {
        if (response) {
          //console.log('save questions response: ', response);
          return response.body;
        } else {
          return error;
        }
      }));
  }

  public updateQuestionResponses(data: any): Observable<any> {
    const url = this.commonService.getFullUrl(GlobalConstants.UPDATE_QUES_RESPONSES);
    let encryptedRqstBody = {
      rqstBody: this.commonService.encryptUsingAES256(data)
    }
    return this._commonHttpService.post(url, encryptedRqstBody, {}, {})
      .pipe(map((response, error) => {
        if (response) {
          //console.log('save questions response: ', response);
          return response.body;
        } else {
          return error;
        }
      }));
  }

  public saveQuestionnaire(data: any): Observable<any> {
    const url = this.commonService.getFullUrl(GlobalConstants.SAVE_QUESTIONNAIRE);
    let encryptedRqstBody = {
      rqstBody: this.commonService.encryptUsingAES256(data)
    }
    return this._commonHttpService.post(url, encryptedRqstBody, {}, {})
      .pipe(map((response, error) => {
        if (response) {
          //console.log('save questionnaire response: ', response);
          return response.body;
        } else {
          return error;
        }
      }));
  }

  public uploadFileToServer(data: any): Observable<any> {
    const url = this.commonService.getFullUrl(GlobalConstants.FILE_UPLOAD);
    let encryptedRqstBody = {
      rqstBody: this.commonService.encryptUsingAES256(data)
    }
    return this._commonHttpService.post(url, encryptedRqstBody, {}, {})
      .pipe(map((response, error) => {
        if (response) {
          //console.log('save file response: ', response);
          return response.body;
        } else {
          return error;
        }
      }));
  }
  public validateAssessment(data: any): Observable<any> {
    const url = this.commonService.getFullUrl(GlobalConstants.VALIDATE_ASSESSMENT);
    let encryptedRqstBody = {
      rqstBody: this.commonService.encryptUsingAES256(data)
    }
    return this._commonHttpService.post(url, encryptedRqstBody, {}, {})
      .pipe(map((response, error) => {
        if (response) {
          return response.body;
        } else {
          return error;
        }
      }));
  }
 public startAssessment(data: any): Observable<any> {
    const url = this.commonService.getFullUrl(GlobalConstants.START_ASSESSMENT);
    let encryptedRqstBody = {
      rqstBody: this.commonService.encryptUsingAES256(data)
    }
    return this._commonHttpService.post(url, encryptedRqstBody, {}, {})
      .pipe(map((response, error) => {
        if (response) {
          return response.body;
        } else {
          return error;
        }
      }));
  }
  public deleteFileFromServer(data: any): Observable<any> {
    const url = this.commonService.getFullUrl(GlobalConstants.FILE_DELETE);
    //console.log("file data:", data)
    let encryptedRqstBody = {
      rqstBody: this.commonService.encryptUsingAES256(data)
    }
    return this._commonHttpService.post(url, encryptedRqstBody, {}, {})
      .pipe(map((response, error) => {
        if (response) {
          //console.log('delete file response: ', response);
          return response.body;
        } else {
          return error;
        }
      }));
  }

  public updateQuestionnaireProgress(data: any): Observable<any> {
    const url = this.commonService.getFullUrl(GlobalConstants.UPDATE_QUESTIONNAIRE_PROGRESS);
    let encryptedRqstBody = {
      rqstBody: this.commonService.encryptUsingAES256(data)
    }
    return this._commonHttpService.post(url, encryptedRqstBody, {}, {})
      .pipe(map((response, error) => {
        if (response) {
          //console.log('update progress questionnaire response: ', response);
          return response.body;
        } else {
          return error;
        }
      }));
  }

  public submitQuestionResponses(data: any): Observable<any> {
    const url = this.commonService.getFullUrl(GlobalConstants.SUBMIT_QUES_RESPONSES);
    let encryptedRqstBody = {
      rqstBody: this.commonService.encryptUsingAES256(data)
    }
    return this._commonHttpService.post(url, encryptedRqstBody, {}, {})
      .pipe(map((response, error) => {
        if (response) {
          //console.log('submit questions response: ', response);
          return response.body;
        } else {
          return error;
        }
      }));
  }

  public fetchExecutorResponses(data: any): Observable<any> {
    const url = this.commonService.getFullUrl(GlobalConstants.FETCH_EXECUTOR_RESPONSE);
    let encryptedRqstBody = {
      rqstBody: this.commonService.encryptUsingAES256(data)
    }
    return this._commonHttpService.post(url, encryptedRqstBody, {}, {})
      .pipe(map((response, error) => {
        if (response) {
          //console.log('fetch questions response: ', response);
          return response.body;
        } else {
          return error;
        }
      }));
  }

  public fetchExecutorResponseId(data: any): Observable<any> {
    const url = this.commonService.getFullUrl(GlobalConstants.FETCH_RESPONSEID);
    let encryptedRqstBody = {
      rqstBody: this.commonService.encryptUsingAES256(data)
    }
    return this._commonHttpService.post(url, encryptedRqstBody, {}, {})
      .pipe(map((response, error) => {
        if (response) {
          //console.log('fetch response id: ', response);
          return response.body;
        } else {
          return error;
        }
      }));
  }
  public fetchExecutorResponseIds(data: any): Observable<any> {
    const url = this.commonService.getFullUrl(GlobalConstants.FETCH_RESPONSEIDS);
    let encryptedRqstBody = {
      rqstBody: this.commonService.encryptUsingAES256(data)
    }
    return this._commonHttpService.post(url, encryptedRqstBody, {}, {})
      .pipe(map((response, error) => {
        if (response) {
          //console.log('fetch response ids: ', response);
          return response.body;
        } else {
          return error;
        }
      }));
  }


  public fetchTotalNoOfQues(data: any): Observable<any> {
    const url = this.commonService.getFullUrl(GlobalConstants.FETCH_TOTAL_NUMBER_OF_QUES);
    let encryptedRqstBody = {
      rqstBody: this.commonService.encryptUsingAES256(data)
    }
    return this._commonHttpService.post(url, encryptedRqstBody, {}, {})
      .pipe(map((response, error) => {
        if (response) {
          //console.log('fetch total number of ques: ', response);
          return response.body;
        } else {
          return error;
        }
      }));
  }

  public fetchRejectedQuestions(data: any): Observable<any> {
    const url = this.commonService.getFullUrl(GlobalConstants.FETCH_REJECTED_QUESTIONS);
    let encryptedRqstBody = {
      rqstBody: this.commonService.encryptUsingAES256(data)
    }
    return this._commonHttpService.post(url, encryptedRqstBody, {}, {})
      .pipe(map((response, error) => {
        if (response) {
          //console.log('fetch rejected questions response: ', response);
          return response.body;
        } else {
          return error;
        }
      }));
  }

  public fetchSupervisorRejectedQuestions(data: any): Observable<any> {
    const url = this.commonService.getFullUrl(GlobalConstants.FETCH_SUPERVISOR_REJECTED_QUESTIONS);
    let encryptedRqstBody = {
      rqstBody: this.commonService.encryptUsingAES256(data)
    }
    return this._commonHttpService.post(url, encryptedRqstBody, {}, {})
      .pipe(map((response, error) => {
        if (response) {
          //console.log('fetch supervisor rejected questions response: ', response);
          return response.body;
        } else {
          return error;
        }
      }));
  }

  public fetchQuestionnaireName(data: any): Observable<any> {
    const url = this.commonService.getFullUrl(GlobalConstants.FETCH_QUESTIONNAIRE_NAME);
    let encryptedRqstBody = {
      rqstBody: this.commonService.encryptUsingAES256(data)
    }
    return this._commonHttpService.post(url, encryptedRqstBody, {}, {})
      .pipe(map((response, error) => {
        if (response) {
          //console.log('fetch questionnaire name response: ', response);
          return response.body;
        } else {
          return error;
        }
      }));
  }

  public fetchAllCases(data: any): Observable<any> {
    const url = this.commonService.getFullUrl(GlobalConstants.FETCH_CASES);
    let encryptedRqstBody = {
      rqstBody: this.commonService.encryptUsingAES256(data)
    }
    return this._commonHttpService.post(url, encryptedRqstBody, {}, {})
      .pipe(map((response, error) => {
        if (response) {
          //console.log('fetch cases response: ', response);
          return response.body;
        } else {
          return error;
        }
      }));
  }

  public fetchCaseDetails(data: any): Observable<any> {
    const url = this.commonService.getFullUrl(GlobalConstants.FETCH_CASE_DETAILS);
    let encryptedRqstBody = {
      rqstBody: this.commonService.encryptUsingAES256(data)
    }
    return this._commonHttpService.post(url, encryptedRqstBody, {}, {})
      .pipe(map((response, error) => {
        if (response) {
          //console.log('fetch case details response: ', response);
          return response.body;
        } else {
          return error;
        }
      }));
  }

  public fetchUserGuidanceData(): Observable<any> {
    const url = this.commonService.getFullUrl(GlobalConstants.FETCH_USER_GUIDANCE_DATA);
    return this._commonHttpService.get(url, {}, {})
      .pipe(map((response, error) => {
        if (response) {
          return response.body;
        } else {
          return error;
        }
      }));
  }

  setProgressDetailsData(progressDetails: any) {
    this.progressDetails = progressDetails;
  }

  getProgressDetailsData() {
    return this.progressDetails;
  }


}
